import React, { Component, PropTypes } from 'react';

import clientFormatter from '../utils/clientFormatter';

export default class ChannelName extends Component {
  static propTypes = {
    client: PropTypes.string,
    name: PropTypes.string,
  }

  static defaultProps = {
    client: 'slack',
  }

  render() {
    const { name, client, ...rest } = this.props;

    const formatter = clientFormatter(client);

    return <span {...rest}>{ formatter.channelName(name) }</span>;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/ChannelName.jsx
 **/